import React from 'react';
import classNames from 'classnames';

const PlanLabel = ({ label = '', highlighted = false, limited = false }) => {
  const classes = classNames('ws-ui-plan-label', {
    'ws-ui-plan-label--highlighted': highlighted,
    'ws-ui-plan-label--limited': limited,
  });

  if (!label) return null;
  return <div className={classes}>{label}</div>;
};

export default PlanLabel;
